import { useNavigate } from "react-router-dom";
import { BackButton } from "../../../components/features/BackButton";
import { paths } from "../../../config/paths";
import { BeautyServiceCard } from "../../../features/beauty-services/components/BeautyServiceCard";
import { fragranceBeautyServices } from "../../../features/beauty-services/data/fragranceBeautyServices";
import { makeupBeautyServices } from "../../../features/beauty-services/data/makeupBeautyServices";
import { getAssetPath } from "../../../lib/assetPath";
import { useTranslation } from "../../../lib/i18n";
import { useDataTranslation } from "../../../lib/i18n/data";

export const BeautyServices = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { tData } = useDataTranslation();
  const homeImagePath = "/looks-gallery/beauty-services/home.avif";
  return (
    <div
      className="flex flex-col overflow-y-auto h-full"
      style={{
        background: "linear-gradient(180deg, #FAF5F1 0%, #F5EEEB 100%)",
      }}
    >
      <div className="absolute top-4 left-4 z-10 text-white w-fit">
        <BackButton onClick={() => navigate(paths.looksGallery.path)} />
      </div>
      <div className="flex flex-col gap-6 py-6 items-center">
        <img
          src={getAssetPath(homeImagePath)}
          alt={homeImagePath}
          className="object-contain"
        />
        <div className="flex flex-col gap-6">
          <div className="flex flex-col px-6 items-center">
            <h2 className="text-[#CE0A2C] text-center font-garamond-italic text-[24px] italic font-normal">
              {t('beautyServices.christianLouboutin')}
            </h2>
            <h1 className="text-[#050505] text-center font-bebas-kai text-[40px] font-normal">
              {t('beautyServices.title')}
            </h1>
          </div>

          <div className="flex flex-col gap-4 px-4">
            <h2 className="flex justify-center items-center gap-6 self-stretch font-garamond-italic text-[22px] font-normal">
              {t('beautyServices.makeup')}
            </h2>
            {makeupBeautyServices.map((service, index) => (
              <BeautyServiceCard
                key={service.title}
                title={tData('makeupServices', String(index), 'title', service.title)}
                description={tData('makeupServices', String(index), 'description', service.description)}
                imagePath={service.imagePath}
                duration={service.duration}
              />
            ))}
          </div>
          <div className="flex flex-col gap-4 px-4">
            <h2 className="flex justify-center items-center gap-6 self-stretch font-garamond-italic text-[22px] font-normal">
              {t('beautyServices.fragrance')}
            </h2>
            {fragranceBeautyServices.map((service, index) => (
              <BeautyServiceCard
                key={service.title}
                title={tData('fragranceServices', String(index), 'title', service.title)}
                description={tData('fragranceServices', String(index), 'description', service.description)}
                imagePath={service.imagePath}
                duration={service.duration}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
